import { computed, watchEffect, watch } from 'vue'
import { useStore } from 'vuex'
import { formatAddress } from '@/utils/address'
import { getMissingAddressFields } from '@/utils/validation'

// eslint-disable-next-line no-unused-vars
export function useAddressFields(props, emit, source = 'courier_address') {
  const store = useStore()

  const userEditProfile = computed(
    () => store.state.checkoutScenario === 'userEditProfile'
  )
  const isSelectedProfile = computed(
    () => store.state.checkoutScenario === 'isSelectedProfile'
  )

  const lastProfile = computed(() => {
    const profile = store.state.SELECTED_PROFILE?.ADDRESS_INFO_FIELDS ?? {}
    if (!profile.CITY && !profile.AREA) return ''

    return {
      formatted: formatAddress(profile),
      PROFILE: { ...profile },
    }
  })

  // переменная обоих сценариев: редактирование юзером и автоввод. Приоритет -- редактирование
  // Если нет сохранённого профиля (lastProfile пуст) — используем modelValue из родителя,
  // чтобы данные, проставленные через switchToHeaderCity, были видны в дочернем компоненте
  const addressInfo = computed({
    get: () =>
      userEditProfile.value
        ? props.modelValue
        : lastProfile.value || props.modelValue,
    set: (v) => emit('update:modelValue', v),
  })
  watch(
    addressInfo,
    (newVal) => {
      emit('update:modelValue', newVal)
    },
    { deep: true }
  )

  const initialAddress = computed(() => {
    const address = addressInfo.value?.PROFILE
    if (!address) return ''
    return formatAddress(address)
  })

  async function autocompleteOrEmitAddress() {
    if (!isSelectedProfile.value || props.hideGmapAutocomplete) {
      emit('update:modelValue', addressInfo.value)
    } else {
      // Сохранённый адрес — используем данные профиля напрямую, без Google API.
      // Ранее вызывался choosePlace() (Autocomplete + Place Details) для каждого
      // сохранённого адреса при всех странах кроме CZ. Это было источником
      // ~90% расхода Google Places API.
      const profileData = addressInfo.value?.PROFILE || {}
      const fieldsConfig = store.state.checkoutFields
      const missingFields = getMissingAddressFields(fieldsConfig, profileData)

      emit('update:modelValue', addressInfo.value)
      props.validateAddressField(initialAddress.value, true)

      if (missingFields.length > 0) {
        console.warn(
          'Сохранённый адрес неполный, отсутствуют поля:',
          missingFields
        )
      }
    }
  }

  watchEffect(async () => {
    if (initialAddress.value) await autocompleteOrEmitAddress()
  })

  return {
    addressInfo,
  }
}
